import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { cocktailActions } from '../_actions';
import { Spinner } from '../Spinner';

class AddIngredient extends React.Component {
    constructor(props) {
        super(props);

        const { ingredients } = this.props;
        if (props.match.params.machine_name && ingredients.items) {
            //alert("OK, lets fetch the machine name!" + props.match.params.machine_name)

            const machine_name = props.match.params.machine_name

            const isIngredient = p => p.machine_name === machine_name
            const ingredient = ingredients.items.find(isIngredient)

            if (!ingredient) {
                return <div>Sorry, but the ingredient was not found</div>
            }

            this.state = {
                ingredient: ingredient,
                submitted: false,
                fetchInProgress: false,
                original_name: ingredient.name
            };
        } else {
            this.state = {
                ingredient: {
                    name: '',
                    category: 'Liquor',
                    container: 'Bottle',
                    amazon: '',
                    img_url: '',
                    _id: ''
                },
                submitted: false,
                fetchInProgress: false
            };
        }

        // No need to bind CLASS METHODS as we now auto-bound these using JavaScript ES6 arrow functions
        // this.handleChange = this.handleChange.bind(this); DONE!
        // this.handleSubmit = this.handleSubmit.bind(this);
    }

    /*
    handleChange(event) {
        const { name, value } = event.target;
        console.log("Where is name & value: ", event.target, event);
        const { ingredient } = this.state;
        this.setState({
            ingredient: {
                ...ingredient,
                [name]: value
            }
        });
    }*/

    handleChange = (event) => {
      const { name, value } = event.target;
      console.log("Where is name & value: ", event.target, event);
      const { ingredient } = this.state;
      this.setState({
          ingredient: {
              ...ingredient,
              [name]: value
          }
      });
    }

    /*handleSubmit(event) {
        event.preventDefault();

        this.setState({ submitted: true });
        const { ingredient, original_name } = this.state;
        const { dispatch } = this.props;
        if (ingredient.name && ingredient.container && ingredient.img_url) {
            dispatch(cocktailActions.addIngredient(ingredient, original_name));
        }
    }*/

    handleSubmit = (event) => {
      event.preventDefault();

      this.setState({ submitted: true });
      const { ingredient, original_name } = this.state;
      const { dispatch } = this.props;
      if (ingredient.name && ingredient.container && ingredient.img_url) {
          dispatch(cocktailActions.addIngredient(ingredient, original_name));
      }
   }

    render() {
        const { contributing  } = this.props;
        const { ingredient, submitted } = this.state;
        return (
            <div className="col-md-6 col-md-offset-3">
                <h2>{this.state.original_name?`Edit ${this.state.original_name}`:'Add Ingredient'}</h2>
                <form name="form" onSubmit={this.handleSubmit}>
                    <div className={'form-group' + (submitted && !ingredient.name ? ' has-error' : '')}>
                        <label htmlFor="name">Name</label>
                        <input type="text" className="form-control" name="name" value={ingredient.name} onChange={this.handleChange} />
                        {submitted && !ingredient.name &&
                            <div className="help-block">Name is required</div>
                        }
                    </div>
                    <div className={'form-group' + (submitted && !ingredient.category ? ' has-error' : '')}>
                        <label htmlFor="category">Category</label>
                        <select className="form-control" name="category" value={ingredient.category} onChange={this.handleChange}>
                            <option value="Liquor">Liquor</option>
                            <option value="Liqueur">Liqueur</option>
                            <option value="Mixer">Mixer</option>
                            <option value="Wine">Wine</option>
                            <option value="Garnishment">Garnishment</option>
                            <option value="Other">Other</option>
                        </select>
                        {submitted && !ingredient.category &&
                            <div className="help-block">Category is required</div>
                        }
                    </div>
                    <div className={'form-group' + (submitted && !ingredient.container ? ' has-error' : '')}>
                        <label htmlFor="container">Container</label>
                        <select className="form-control" name="container" value={ingredient.container} onChange={this.handleChange}>
                            <option value="Bottle">Bottle</option>
                            <option value="Jar">Jar</option>
                            <option value="Box">Box</option>
                            <option value="Carton">Carton</option>
                            <option value="Can">Can</option>
                            <option value="Bag">Bag</option>
                        </select>
                        {submitted && !ingredient.container &&
                            <div className="help-block">Container is required</div>
                        }
                    </div>
                    <div className={'form-group' + (submitted && ingredient.amazon.indexOf('amazon-adsystem') === -1 ? ' has-error' : '')}>
                        <label htmlFor="amazon">Amazon Widget</label>
                        <input type="text" className="form-control" name="amazon" value={ingredient.amazon} onChange={this.handleChange} />
                        {submitted && ingredient.amazon.indexOf('amazon-adsysten') === -1 &&
                        <div className="help-block">Amazon Widget is not formatted properly</div>
                        }
                    </div>
                    <div className={'form-group' + (submitted && !ingredient.img_url ? ' has-error' : '')}>
                        <label htmlFor="img_url">Image URL</label>
                        <input type="text" className="form-control" name="img_url" value={ingredient.img_url} onChange={this.handleChange} />
                        {submitted && !ingredient.img_url &&
                            <div className="help-block">Image URL is required</div>
                        }
                    </div>
                    <div className={'form-group' + (submitted && !ingredient._id ? ' has-error' : '')}>
                        <input type="hidden" className="form-control" name="_id" value={ingredient._id} onChange={this.handleChange} />
                    </div>
                    <div className="form-group">
                        <button className="btn btn-primary">{this.state.original_name?"Save Changes":"Add Ingredient"}</button>
                        {contributing &&
                            <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                        }
                        <Link to="/ingredient" className="btn btn-link">Cancel</Link>
                    </div>
                </form>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { ingredients, contribution } = state;
    const { contributing } = state.contribution;
    const { ingredient } = contribution;
    return {
        contributing,
        ingredient,
        ingredients
    };
}

const connectedAddIngredient = connect(mapStateToProps)(AddIngredient);
export { connectedAddIngredient as AddIngredient };


// WEBPACK FOOTER //
// ./src/AddIngredient/AddIngredient.jsx